import { Link } from "react-router-dom";
import { ArticleMeta } from "@/components/site/Meta";

export const ArticleItem = ({ article, index = 0 }) => (
  <article
    data-testid={`article-card-${article.slug}`}
    className="fade-up py-8 border-b border-[var(--rule)] last:border-b-0 grid gap-3"
    style={{ animationDelay: `${120 + index * 70}ms` }}
  >
    <ArticleMeta article={article} idPrefix={`article-card-${article.slug}`} />
    <h3 className="font-display text-2xl sm:text-[1.7rem] font-semibold leading-snug tracking-tight">
      <Link to={`/article/${article.slug}`} className="headline-link" data-testid={`article-card-link-${article.slug}`}>
        {article.headline}
      </Link>
    </h3>
    {article.standfirst && <p className="text-[var(--ink-2)] leading-relaxed max-w-2xl">{article.standfirst}</p>}
  </article>
);

export const ArticleList = ({ articles, empty = "Nothing published here yet.", testId = "article-list" }) =>
  articles.length ? (
    <div data-testid={testId}>
      {articles.map((a, i) => <ArticleItem key={a.id} article={a} index={i} />)}
    </div>
  ) : (
    <p className="py-12 text-[var(--ink-3)] italic" data-testid={`${testId}-empty`}>{empty}</p>
  );
